import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import http from './../../services/Api'
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap';
import Logo from './../../assets/img/ares-logo.png'
import swal from 'sweetalert';

import './index.css'
import { RiLoader4Line } from 'react-icons/ri';
import { AiFillMail } from 'react-icons/ai';

function ForgotPassword() {
  const { register, handleSubmit } = useForm();
  const [loading, setLoading] = useState(null);
  const history = useHistory();

  const save = async data => {
    const { email } = data;
    let code = `${parseInt(Math.random().toFixed(5) * 100000)}`;
    setLoading(true)
    try {
      await http.post('api/password/request/reset',  {
        code,
        email
      })
      swal("Em instantes você recebera o código em seu email para alteração da senha",
        {
          title: "Sucesso!",
          buttons: {
            login: {
              text: "Alterar senha",
              value: "login",
            },
          },
          icon: "success",
        })
        .then((value) => {
          if (value === 'login') {
            history.push('/reset-password', email);
          }
        });
    } catch (e) {
      swal("Erro!", e.response.data.error, "error");
    }
    setLoading(false);
  }

  return (
    <div className="Register">
      <div className="content">
        <div className="left">
          <div className="container-img">
            <img src={Logo} alt="logo" />
          </div>
          <div className="copyright">
            Copyright © 2021 Synapse Brasil, Inc.
          </div>
        </div>

        <div className="right">
          <Form method="POST" onSubmit={handleSubmit(save)} className="Password-recover">
            <div className="text-center">
              <h1>Recuperação de senha</h1>
            </div>
            <div className="explanation">
              <p>Insira no campo abaixo o seu e-mail para que possamos
              encaminhar o <i>código</i> para alteração de sua senha.</p>
            </div>
            <br />
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text id="inputGroupPrepend">
                  <AiFillMail size="1.2em" />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control type="email" placeholder="Email de Recuperação" name="email" ref={register} required />
            </InputGroup>
            <br />
            <Row>
              <Col>
                <Button variant="default" type="button" onClick={() => {
                  history.push('/login');
                }}>
                  Voltar
                </Button>
              </Col>
              <Col>
                <Button variant="primary" type="submit">
                  {loading ? (<RiLoader4Line className="spin" />) : 'Enviar'}
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword;